import { appRouterPaths } from 'services/navigation';
import { MaxLessonsPerDayPage } from 'pages/MaxLessonsPerDay';
import type { AppRouteProps } from '../types';

export const maxLessonsPerDayPageRoute: AppRouteProps = {
  path: appRouterPaths.maxLessonsPerDay,
  element: <MaxLessonsPerDayPage />,
};
